export default __webpack_public_path__ + "static/media/Pay.d6dc0a5e.svg";